import { Avatar, Checkbox, CheckboxProps } from '@mui/material';
import { RadioChecked, UncheckedIcon } from 'Images';

export const SimpleCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      icon={
        <Avatar
          alt=''
          src={UncheckedIcon}
          sx={{ width: '24px', height: '24px' }}
        />
      }
      checkedIcon={
        <Avatar
          alt=''
          src={RadioChecked}
          sx={{ width: '24px', height: '24px' }}
        />
      }
      {...props}
    />
  );
};
